import { MantineColorsTuple, rgba } from "@mantine/core";
import { MantineTheme } from "../mantine";

export const darkColorsTuple: MantineColorsTuple = [
    "#F4F4F5",
    "#CBCBCB",
    "#8B909C",
    "#767B84",
    "#5C6067",
    "#4A4D53",
    "#474A50",
    "#3C3F45",
    "#323439",
    "#242529",
];
export const grayColorsTuple: MantineColorsTuple = [
    "#F8F9FA",
    "#F1F3F5",
    "#E9ECEF",
    "#DEE2E6",
    "#CED4DA",
    "#ADB5BD",
    "#868E96",
    "#495057",
    "#343A40",
    "#212529",
];
export const blueColorsTuple: MantineColorsTuple = [
    "#E7F5FF",
    "#D0EBFF",
    "#A5D8FF",
    "#74C0FC",
    "#4DABF7",
    "#339AF0",
    "#228BE6",
    "#1C7ED6",
    "#1971C2",
    "#1864AB",
];
type MantineOverritenTokens = "--border-default-color" | "--mantine-color-body";
type SurfaceTokens =
    | "--surface-subtle-default"
    | "--surface-subtle-hover"
    | "--surface-page-color"
    | "--surface-container-color"
    | "--surface-default-color"
    | "--surface-overlay-color"
    | "--surface-solid-1-color"
    | "--surface-solid-2-color"
    | "--surface-gray-fade"
    | "--surface-gray-transparent"
    | "--surface-gray-transparent-hover"
    | "--surface-primary-solid-color"
    | "--surface-primary-prominent-color"
    | "--surface-primary-transparent-color"
    | "--surface-primary-transparent-hover-color"
    | "--surface-violet-prominent-color"
    | "--surface-violet-transparent-color"
    | "--surface-success-prominent-color"
    | "--surface-success-transparent-color"
    | "--surface-error-prominent-color"
    | "--surface-error-transparent-color"
    | "--surface-cyan-prominent-color"
    | "--surface-cyan-transparent-color"
    | "--surface-pink-solid-color"
    | "--surface-pink-transparent-color"
    | "--surface-pink-prominent-color"
    | "--surface-pink-fade-color"
    | "--surface-gray-transparent-color"
    | "--surface-gray-transparent-hover-color";

type OverritenTokens = MantineOverritenTokens &
    SurfaceTokens &
    (
        | "--border-transparent-default-1-color"
        | "--border-transparent-default-2-color"
        | "--border-highlight-default-color"
        | "--mantine-color-title-1"
        | "--mantine-color-title-2"
        | "--mantine-color-default"
        | "--mantine-color-default-hover"
        | "--mantine-color-surface-container"
        | "--mantine-color-surface-container-border"
        | "--mantine-color-primary-filled"
        | "--mantine-color-primary-filled-hover"
        | "--mantine-color-primary-light"
        | "--mantine-color-primary-light-hover"
        | "--mantine-color-primary-fade-1"
        | "--mantine-color-primary-fade-2"
        | "--mantine-color-transparent-default"
        | "--mantine-color-disabled-default"
        | "--mantine-color-success-filled"
        | "--mantine-color-success-filled-hover"
        | "--mantine-color-success-light"
        | "--mantine-color-success-light-hover"
        | "--mantine-color-success-fade-1"
        | "--mantine-color-success-fade-2"
        | "--mantine-color-warning-filled"
        | "--mantine-color-warning-filled-hover"
        | "--mantine-color-warning-light"
        | "--mantine-color-warning-light-hover"
        | "--mantine-color-warning-fade-1"
        | "--mantine-color-warning-fade-2"
        | "--mantine-color-error-filled"
        | "--mantine-color-error-filled-hover"
        | "--mantine-color-error-light"
        | "--mantine-color-error-light-hover"
        | "--mantine-color-error-fade-1"
        | "--mantine-color-error-fade-2"
        | "--mantine-color-text-title-1"
        | "--mantine-color-text-title-2"
        | "--mantine-color-text-default"
        | "--mantine-color-text-dimmed"
        | "--mantine-color-text-link"
        | "--mantine-color-text-placeholder"
        | "--mantine-color-text-primary-default"
        | "--mantine-color-text-primary-fade-1"
        | "--mantine-color-text-primary-fade-2"
        | "--mantine-color-text-disabled"
        | "--mantine-color-text-success-default"
        | "--mantine-color-text-success-fade-1"
        | "--mantine-color-text-success-fade-2"
        | "--mantine-color-text-warning-default"
        | "--mantine-color-text-warning-fade-1"
        | "--mantine-color-text-warning-fade-2"
        | "--mantine-color-text-error-default"
        | "--mantine-color-text-error-fade-1"
        | "--mantine-color-text-error-fade-2"
        | "--mantine-color-text-error-disabled"
        | "--mantine-color-text-indigo-fade-1"
        | "--mantine-color-text-indigo-fade-2"
        | "--mantine-color-text-grape-fade-1"
        | "--mantine-color-text-grape-fade-2"
        | "--mantine-color-text-cyan-fade-1"
        | "--mantine-color-text-cyan-fade-2"
        | "--mantine-color-text-orange-fade-1"
        | "--mantine-color-text-orange-fade-2"
        | "--mantine-color-text-violet-default"
        | "--mantine-color-text-violet-fade-1"
        | "--mantine-color-text-violet-fade-2"
        | "--mantine-color-text-pink-fade-1"
        | "--mantine-color-text-pink-fade-2"
        | "--mantine-color-border-default"
        | "--mantine-color-border-primary-default"
        | "--mantine-color-border-transparent-default-1"
        | "--mantine-color-border-transparent-default-2"
        | "--mantine-color-border-highlight-default-1"
        | "--mantine-color-border-highlight-default-2"
        | "--mantine-color-border-warning-default"
        | "--mantine-color-border-success-default"
        | "--mantine-color-border-error-default"
        | "--mantine-color-border-gray-default"
        | "--menu-item-section-color"
        | "--menu-item-section-color-hover"
        | "--input-section-right-color"
        | "--mantine-color-neutral-0"
        | "--mantine-color-neutral-1"
        | "--mantine-color-neutral-2"
        | "--mantine-color-neutral-3"
        | "--mantine-color-neutral-4"
        | "--mantine-color-neutral-5"
        | "--mantine-color-neutral-6"
        | "--mantine-color-neutral-7"
        | "--mantine-color-neutral-8"
        | "--mantine-color-neutral-9"
    );

export const lightColors = (theme: MantineTheme): Record<OverritenTokens, string> => {
    return {
        // Surface
        "--surface-subtle-default": rgba(theme.black, 0.1),
        "--surface-subtle-hover": rgba(theme.black, 0.04),
        "--surface-page-color": theme.colors.gray[1],
        "--mantine-color-body": "var(--surface-page-color)",
        "--surface-container-color": theme.white,
        "--surface-default-color": theme.white,
        "--surface-overlay-color": theme.white,
        "--surface-solid-1-color": theme.white,
        "--surface-solid-2-color": theme.black,
        "--surface-permanent-1-color": theme.white,
        "--surface-permanent-2-color": theme.black,

        // Surface/gray
        "--surface-gray-solid": theme.colors.gray[6],
        "--surface-gray-solid-hover": theme.colors.gray[7],
        "--surface-gray-transparent": rgba(theme.colors.gray[6], 0.1),
        "--surface-gray-transparent-hover": rgba(theme.colors.gray[6], 0.15),
        "--surface-gray-fade": theme.colors.gray[1],

        // Surface/Violet
        "--surface-violet-solid": theme.colors.violet[5],

        // Surface/success
        "--surface-success-solid": theme.colors.teal[6],
        "--surface-success-solid-hover": theme.colors.teal[7],
        "--surface-success-transparent": rgba(theme.colors.teal[6], 0.1),
        "--surface-success-transparent-hover": rgba(theme.colors.teal[6], 0.15),
        "--surface-success-prominent": theme.colors.teal[9],
        "--surface-success-fade": theme.colors.teal[1],

        // Surface/primary
        "--surface-primary-solid": theme.colors.blue[6],
        "--surface-primary-solid-hover": theme.colors.blue[7],
        "--surface-primary-transparent": rgba(theme.colors.blue[6], 0.1),
        "--surface-primary-transparent-hover": rgba(theme.colors.blue[6], 0.15),
        "--surface-primary-prominent": theme.colors.blue[9],
        "--surface-primary-fade": theme.colors.blue[1],

        // Surface/warning
        "--surface-warning-solid-color": theme.colors.yellow[6],
        "--surface-warning-solid-hover-color": theme.colors.yellow[7],
        "--surface-warning-transparent-color": rgba(theme.colors.yellow[6], 0.1),
        "--surface-warning-transparent-hover-color": rgba(theme.colors.yellow[6], 0.15),
        "--surface-warning-prominent-color": theme.colors.yellow[9],
        "--surface-warning-fade-color": theme.colors.yellow[1],

        // Surface/error
        "--surface-error-solid": theme.colors.red[6],
        "--surface-error-solid-hover": theme.colors.red[7],
        "--surface-error-transparent": rgba(theme.colors.red[6], 0.1),
        "--surface-error-transparent-hover": rgba(theme.colors.red[6], 0.15),
        "--surface-error-prominent": theme.colors.red[9],
        "--surface-error-fade": theme.colors.red[1],

        "--surface-primary-solid-color": "var(--mantine-primary-color-6)",
        "--surface-primary-prominent-color": theme.colors.blue[9],
        "--surface-primary-transparent-color": rgba(theme.colors.blue[6], 0.1),
        "--surface-primary-transparent-hover-color": rgba(theme.colors.blue[6], 0.15),

        "--surface-violet-prominent-color": theme.colors.violet[9],
        "--surface-violet-transparent-color": rgba(theme.colors.violet[6], 0.1),
        "--surface-success-prominent-color": theme.colors.teal[9],
        "--surface-success-transparent-color": rgba(theme.colors.teal[6], 0.1),
        "--surface-error-prominent-color": theme.colors.red[9],
        "--surface-error-transparent-color": rgba(theme.colors.red[6], 0.1),
        "--surface-cyan-prominent-color": theme.colors.cyan[9],
        "--surface-cyan-transparent-color": rgba(theme.colors.cyan[6], 0.1),

        // Surface/pink
        "--surface-pink-solid-color": theme.colors.pink[5],
        "--surface-pink-transparent-color": rgba(theme.colors.pink[6], 0.1),
        "--surface-pink-prominent-color": theme.colors.pink[9],
        "--surface-pink-fade-color": theme.colors.pink[1],

        "--surface-gray-transparent-color": rgba(theme.colors.gray[6], 0.1),
        "--surface-gray-transparent-hover-color": rgba(theme.colors.blue[6], 0.15),

        // Border
        "--border-transparent-default-1-color": rgba(theme.black, 0.1),
        "--border-transparent-default-2-color": rgba(theme.white, 0.15),
        "--border-highlight-default-color": rgba(theme.white, 0),
        "--border-default-color": theme.colors.gray[3],

        "--mantine-color-title-1": theme.white,
        "--mantine-color-title-2": theme.black,
        "--mantine-color-default": theme.white,
        "--mantine-color-default-hover": rgba(theme.black, 0.04),
        "--mantine-color-surface-container": theme.white,
        "--mantine-color-surface-container-border": rgba(theme.white, 0),

        "--mantine-color-primary-filled": theme.colors.blue[6],
        "--mantine-color-primary-filled-hover": theme.colors.blue[7],
        "--mantine-color-primary-light": rgba(theme.colors.blue[6], 0.1),
        "--mantine-color-primary-light-hover": rgba(theme.colors.blue[6], 0.15),
        "--mantine-color-primary-fade-1": theme.colors.blue[9],
        "--mantine-color-primary-fade-2": theme.colors.blue[1],

        "--mantine-color-transparent-default": rgba(theme.black, 0.1),
        "--mantine-color-disabled-default": theme.colors.gray[1],

        "--mantine-color-success-filled": theme.colors.teal[6],
        "--mantine-color-success-filled-hover": theme.colors.teal[7],
        "--mantine-color-success-light": rgba(theme.colors.teal[6], 0.1),
        "--mantine-color-success-light-hover": rgba(theme.colors.teal[6], 0.15),
        "--mantine-color-success-fade-1": theme.colors.teal[9],
        "--mantine-color-success-fade-2": theme.colors.teal[1],

        "--mantine-color-warning-filled": theme.colors.yellow[6],
        "--mantine-color-warning-filled-hover": theme.colors.yellow[7],
        "--mantine-color-warning-light": rgba(theme.colors.yellow[6], 0.1),
        "--mantine-color-warning-light-hover": rgba(theme.colors.yellow[6], 0.15),
        "--mantine-color-warning-fade-1": theme.colors.yellow[9],
        "--mantine-color-warning-fade-2": theme.colors.yellow[1],

        "--mantine-color-error-filled": theme.colors.red[6],
        "--mantine-color-error-filled-hover": theme.colors.red[7],
        "--mantine-color-error-light": rgba(theme.colors.red[6], 0.1),
        "--mantine-color-error-light-hover": rgba(theme.colors.red[6], 0.15),
        "--mantine-color-error-fade-1": theme.colors.red[9],
        "--mantine-color-error-fade-2": theme.colors.red[1],

        /* Text */
        "--mantine-color-text-title-1": "#FFFFFF",
        "--mantine-color-text-title-2": "#000000",
        "--mantine-color-text-default": theme.colors.gray[9],
        "--mantine-color-text-dimmed": theme.colors.gray[6],
        "--mantine-color-text-link": theme.colors.blue[6],
        "--mantine-color-text-placeholder": theme.colors.gray[5],

        /* Text / Primary */
        "--mantine-color-text-primary-default": "var(--mantine-primary-color-6)",
        "--mantine-color-text-primary-prominent": theme.colors.blue[9],
        "--mantine-color-text-primary-fade-1": theme.colors.blue[9],
        "--mantine-color-text-primary-fade-2": theme.colors.blue[1],

        /* Text / Disabled */
        "--mantine-color-text-disabled": theme.colors.gray[5],

        /* Text / Success */
        "--mantine-color-text-success-default": theme.colors.teal[6],
        "--mantine-color-text-success-prominent": theme.colors.teal[9],
        "--mantine-color-text-success-fade-1": theme.colors.teal[9],
        "--mantine-color-text-success-fade-2": theme.colors.teal[1],

        /* Text / Warning */
        "--mantine-color-text-warning-default": theme.colors.yellow[6],
        "--mantine-color-text-warning-prominent": theme.colors.yellow[9],
        "--mantine-color-text-warning-fade": theme.colors.yellow[1],
        "--mantine-color-text-warning-fade-1": theme.colors.yellow[9],
        "--mantine-color-text-warning-fade-2": theme.colors.yellow[1],

        /* Text / Error */
        "--mantine-color-text-error-default": theme.colors.red[6],
        "--mantine-color-text-error-prominent": theme.colors.red[9],
        "--mantine-color-text-error-fade": theme.colors.red[1],
        "--mantine-color-text-error-fade-1": theme.colors.red[9],
        "--mantine-color-text-error-fade-2": theme.colors.red[1],
        "--mantine-color-text-error-disabled": theme.colors.red[4],

        /* Text / Indigo */
        "--mantine-color-text-indigo-fade-1": theme.colors.indigo[9],
        "--mantine-color-text-indigo-fade-2": theme.colors.indigo[1],

        /* Text / Grape */
        "--mantine-color-text-grape-fade-1": theme.colors.grape[9],
        "--mantine-color-text-grape-fade-2": theme.colors.grape[1],

        /* Text / Cyan */
        "--mantine-color-text-cyan-fade-1": theme.colors.cyan[9],
        "--mantine-color-text-cyan-fade-2": theme.colors.cyan[1],

        /* Text / Orange */
        "--mantine-color-text-orange-fade-1": theme.colors.orange[9],
        "--mantine-color-text-orange-fade-2": theme.colors.orange[1],

        /* Text / Violet */
        "--mantine-color-text-violet-default": theme.colors.violet[5],
        "--mantine-color-text-violet-fade-1": theme.colors.violet[9],
        "--mantine-color-text-violet-fade-2": theme.colors.violet[1],

        /* Text / Pink */
        "--mantine-color-text-pink-fade-1": theme.colors.pink[9],
        "--mantine-color-text-pink-fade-2": theme.colors.pink[1],

        /* Border */
        "--mantine-color-border-default": theme.colors.gray[3],

        "--mantine-color-border-primary-default": theme.colors.blue[6],

        "--mantine-color-border-transparent-default-1": "rgba(0, 0, 0, 0.1)",
        "--mantine-color-border-transparent-default-2": "rgba(255, 255, 255, 0.13)",

        "--mantine-color-border-highlight-default-1": "#FFFFFF",
        "--mantine-color-border-highlight-default-2": "rgba(255, 255, 255, 0)",

        "--mantine-color-border-warning-default": theme.colors.yellow[6],
        "--mantine-color-border-success-default": theme.colors.teal[6],
        "--mantine-color-border-error-default": theme.colors.red[6],
        "--mantine-color-border-gray-default": theme.colors.gray[6],

        // Menu Item
        "--menu-item-section-color": theme.colors.gray[6],
        "--menu-item-section-color-hover": theme.colors.gray[9],

        // Input
        "--input-section-right-color": theme.colors.gray[9],

        // Neutral colors
        "--mantine-color-neutral-0": theme.colors.gray[0],
        "--mantine-color-neutral-1": theme.colors.gray[1],
        "--mantine-color-neutral-2": theme.colors.gray[2],
        "--mantine-color-neutral-3": theme.colors.gray[3],
        "--mantine-color-neutral-4": theme.colors.gray[4],
        "--mantine-color-neutral-5": theme.colors.gray[5],
        "--mantine-color-neutral-6": theme.colors.gray[6],
        "--mantine-color-neutral-7": theme.colors.gray[7],
        "--mantine-color-neutral-8": theme.colors.gray[8],
        "--mantine-color-neutral-9": theme.colors.gray[9],
    };
};

export const darkColors = (theme: MantineTheme): Record<OverritenTokens, string> => {
    return {
        // Surface
        "--surface-subtle-default": rgba(theme.white, 0.12),
        "--surface-subtle-hover": rgba(theme.white, 0.05),
        "--surface-page-color": theme.colors.dark[9],
        "--mantine-color-body": "var(--surface-page-color)",
        "--surface-container-color": theme.colors.dark[8],
        "--surface-default-color": theme.colors.dark[5],
        "--surface-overlay-color": theme.colors.dark[7],
        "--surface-solid-1-color": theme.black,
        "--surface-solid-2-color": theme.white,
        "--surface-permanent-1-color": theme.white,
        "--surface-permanent-2-color": theme.black,

        // Surface/gray
        "--surface-gray-solid": theme.colors.dark[2],
        "--surface-gray-solid-hover": theme.colors.gray[6],
        "--surface-gray-transparent": rgba(theme.colors.gray[6], 0.15),
        "--surface-gray-transparent-hover": rgba(theme.colors.gray[6], 0.2),
        "--surface-gray-fade": theme.colors.dark[5],

        // Surface/Violet
        "--surface-violet-solid": theme.colors.violet[3],

        // Surface/primary
        "--surface-primary-solid": theme.colors.blue[5],

        // Surface/success
        "--surface-success-solid": theme.colors.teal[5],
        "--surface-success-solid-hover": theme.colors.teal[6],
        "--surface-success-transparent": rgba(theme.colors.teal[3], 0.15),
        "--surface-success-transparent-hover": rgba(theme.colors.teal[3], 0.2),
        "--surface-success-prominent": theme.colors.teal[3],
        "--surface-success-fade": theme.colors.teal[9],

        // Surface/warning
        "--surface-warning-solid-color": theme.colors.yellow[5],
        "--surface-warning-solid-hover-color": theme.colors.yellow[6],
        "--surface-warning-transparent-color": rgba(theme.colors.yellow[3], 0.15),
        "--surface-warning-transparent-hover-color": rgba(theme.colors.yellow[3], 0.2),
        "--surface-warning-prominent-color": theme.colors.yellow[3],
        "--surface-warning-fade-color": theme.colors.yellow[9],

        // Surface/error
        "--surface-error-solid": theme.colors.red[5],
        "--surface-error-solid-hover": theme.colors.red[6],
        "--surface-error-transparent": rgba(theme.colors.red[3], 0.15),
        "--surface-error-transparent-hover": rgba(theme.colors.red[3], 0.2),
        "--surface-error-prominent": theme.colors.red[3],
        "--surface-error-fade": theme.colors.red[9],

        "--surface-primary-solid-color": "var(--mantine-primary-color-5)",
        "--surface-primary-prominent-color": theme.colors.blue[3],
        "--surface-primary-transparent-color": rgba(theme.colors.blue[3], 0.15),
        "--surface-primary-transparent-hover-color": rgba(theme.colors.blue[3], 0.2),
        "--surface-violet-prominent-color": theme.colors.violet[3],
        "--surface-violet-transparent-color": rgba(theme.colors.violet[3], 0.15),
        "--surface-error-prominent-color": theme.colors.red[3],
        "--surface-error-transparent-color": rgba(theme.colors.red[3], 0.15),
        "--surface-cyan-prominent-color": theme.colors.cyan[3],
        "--surface-cyan-transparent-color": rgba(theme.colors.cyan[3], 0.15),

        // Surface/pink
        "--surface-pink-solid-color": theme.colors.pink[3],
        "--surface-pink-transparent-color": rgba(theme.colors.pink[3], 0.15),
        "--surface-pink-prominent-color": theme.colors.pink[3],
        "--surface-pink-fade-color": theme.colors.pink[9],

        "--surface-gray-transparent-color": rgba(theme.colors.gray[6], 0.15),
        "--surface-gray-transparent-hover-color": rgba(theme.colors.blue[6], 0.2),

        // Border
        "--border-transparent-default-1-color": rgba(theme.white, 0.15),
        "--border-transparent-default-2-color": rgba(theme.black, 0.1),
        "--border-highlight-default-color": theme.colors.dark[6],
        "--border-default-color": theme.colors.dark[4],

        "--mantine-color-title-1": "#000000",
        "--mantine-color-title-2": "#FFFFFF",
        "--mantine-color-default": theme.colors.dark[6],
        "--mantine-color-default-hover": "rgba(255, 255, 255, 0.05)",
        "--mantine-color-surface-container": theme.colors.dark[8],
        "--mantine-color-surface-container-border": theme.colors.dark[6],

        "--mantine-color-primary-filled": theme.colors.blue[5],
        "--mantine-color-primary-filled-hover": theme.colors.blue[6],
        "--mantine-color-primary-light": rgba(theme.colors.blue[5], 0.1),
        "--mantine-color-primary-light-hover": rgba(theme.colors.blue[5], 0.2),
        "--mantine-color-primary-fade-1": theme.colors.blue[3],
        "--mantine-color-primary-fade-2": theme.colors.blue[9],

        "--mantine-color-transparent-default": "rgba(255, 255, 255, 0.13)",
        "--mantine-color-disabled-default": "rgba(0, 0, 0, 0)",

        "--mantine-color-success-filled": theme.colors.teal[5],
        "--mantine-color-success-filled-hover": theme.colors.teal[6],
        "--mantine-color-success-light": rgba(theme.colors.teal[5], 0.15),
        "--mantine-color-success-light-hover": rgba(theme.colors.teal[5], 0.2),
        "--mantine-color-success-fade-1": theme.colors.teal[3],
        "--mantine-color-success-fade-2": theme.colors.teal[9],

        "--mantine-color-warning-filled": theme.colors.yellow[5],
        "--mantine-color-warning-filled-hover": theme.colors.yellow[6],
        "--mantine-color-warning-light": rgba(theme.colors.yellow[5], 0.15),
        "--mantine-color-warning-light-hover": rgba(theme.colors.yellow[5], 0.2),
        "--mantine-color-warning-fade-1": theme.colors.yellow[3],
        "--mantine-color-warning-fade-2": theme.colors.yellow[9],

        "--mantine-color-error-filled": theme.colors.red[5],
        "--mantine-color-error-filled-hover": theme.colors.red[6],
        "--mantine-color-error-light": rgba(theme.colors.red[5], 0.15),
        "--mantine-color-error-light-hover": rgba(theme.colors.red[5], 0.2),
        "--mantine-color-error-fade-1": theme.colors.red[3],
        "--mantine-color-error-fade-2": theme.colors.red[9],

        /* Text */
        "--mantine-color-text-title-1": "#000000",
        "--mantine-color-text-title-2": "#FFFFFF",
        "--mantine-color-text-default": theme.colors.dark[0],
        "--mantine-color-text-dimmed": theme.colors.dark[3],
        "--mantine-color-text-link": theme.colors.blue[5],
        "--mantine-color-text-placeholder": theme.colors.dark[5],
        "--mantine-color-blue-filled": "var(--mantine-color-text-primary-default)",

        /* Text / Primary */
        "--mantine-color-text-primary-default": "var(--mantine-primary-color-3)",
        "--mantine-color-text-primary-fade-1": theme.colors.blue[3],
        "--mantine-color-text-primary-fade-2": theme.colors.blue[9],

        /* Text / Disabled */
        "--mantine-color-text-disabled": theme.colors.dark[5],

        /* Text / Success */
        "--mantine-color-text-success-default": theme.colors.teal[5],
        "--mantine-color-text-success-fade-1": theme.colors.teal[3],
        "--mantine-color-text-success-fade-2": theme.colors.teal[9],

        /* Text / Warning */
        "--mantine-color-text-warning-default": theme.colors.yellow[5],
        "--mantine-color-text-warning-prominent": theme.colors.yellow[3],
        "--mantine-color-text-warning-fade": theme.colors.yellow[9],
        "--mantine-color-text-warning-fade-1": theme.colors.yellow[3],
        "--mantine-color-text-warning-fade-2": theme.colors.yellow[9],

        /* Text / Error */
        "--mantine-color-text-error-default": theme.colors.red[5],
        "--mantine-color-text-error-prominent": theme.colors.red[3],
        "--mantine-color-text-error-fade": theme.colors.red[9],
        "--mantine-color-text-error-fade-1": theme.colors.red[3],
        "--mantine-color-text-error-fade-2": theme.colors.red[9],
        "--mantine-color-text-error-disabled": "rgba(224, 49, 49, 0.5)",

        /* Text / Indigo */
        "--mantine-color-text-indigo-fade-1": theme.colors.indigo[3],
        "--mantine-color-text-indigo-fade-2": theme.colors.indigo[9],

        /* Text / Grape */
        "--mantine-color-text-grape-fade-1": theme.colors.grape[3],
        "--mantine-color-text-grape-fade-2": theme.colors.grape[9],

        /* Text / Cyan */
        "--mantine-color-text-cyan-fade-1": theme.colors.cyan[1],
        "--mantine-color-text-cyan-fade-2": theme.colors.cyan[9],

        /* Text / Orange */
        "--mantine-color-text-orange-fade-1": theme.colors.orange[3],
        "--mantine-color-text-orange-fade-2": theme.colors.orange[9],

        /* Text / Violet */
        "--mantine-color-text-violet-default": theme.colors.violet[3],
        "--mantine-color-text-violet-fade-1": theme.colors.violet[3],
        "--mantine-color-text-violet-fade-2": theme.colors.violet[9],

        /* Text / Pink */
        "--mantine-color-text-pink-fade-1": theme.colors.pink[3],
        "--mantine-color-text-pink-fade-2": theme.colors.pink[9],

        /* Border */

        "--mantine-color-border-default": theme.colors.dark[5],

        "--mantine-color-border-primary-default": theme.colors.blue[5],

        "--mantine-color-border-transparent-default-1": "rgba(255, 255, 255, 0.13)",
        "--mantine-color-border-transparent-default-2": "rgba(0, 0, 0, 0.1)",

        "--mantine-color-border-highlight-default-1": "rgba(0, 0, 0, 0)",
        "--mantine-color-border-highlight-default-2": theme.colors.dark[7],

        "--mantine-color-border-warning-default": theme.colors.yellow[5],
        "--mantine-color-border-success-default": theme.colors.teal[5],
        "--mantine-color-border-error-default": theme.colors.red[5],
        "--mantine-color-border-gray-default": theme.colors.gray[4],

        // Menu Item
        "--menu-item-section-color": theme.colors.dark[2],
        "--menu-item-section-color-hover": theme.colors.dark[0],

        // Input
        "--input-section-right-color": theme.colors.dark[0],

        // Neutral colors
        "--mantine-color-neutral-0": theme.colors.dark[9],
        "--mantine-color-neutral-1": theme.colors.dark[9],
        "--mantine-color-neutral-2": theme.colors.dark[8],
        "--mantine-color-neutral-3": theme.colors.dark[5],
        "--mantine-color-neutral-4": theme.colors.dark[3],
        "--mantine-color-neutral-5": theme.colors.dark[4],
        "--mantine-color-neutral-6": theme.colors.dark[2],
        "--mantine-color-neutral-7": theme.colors.dark[1],
        "--mantine-color-neutral-8": theme.colors.dark[7],
        "--mantine-color-neutral-9": theme.colors.dark[0],
    };
};
